import {createTask$, deleteTask$, getTasks$, updateTask$} from "../services/projects";
import {networkError} from "./ui";
import {extractSubview} from "./view";

export const ADD_TASKS = 'ADD_TASKS';
export const addTasks = (list) => ({type: ADD_TASKS, payload: list});
export const API_GET_TASKS = 'API_GET_TASKS';
export const getTasks = (projectId, offset) => ({type: API_GET_TASKS, payload: {projectId, offset}});
export const API_GET_TASKS_DONE = 'API_GET_TASKS_DONE';
export const getTasksDone = (response) => ({type: API_GET_TASKS_DONE, payload: response});
export const API_GET_TASK = 'API_GET_TASK';
export const getTask = (projectId, id) => ({type: API_GET_TASK, payload: {projectId, id}});
export const API_GET_TASK_DONE = 'API_GET_TASK_DONE';
export const getTaskDone = (response, callback) => ({ type: API_GET_TASK_DONE, payload: { response, callback } });

export const createTask = (projectId, task, callback) => async (dispatch, getState) => {
  try {
    let { response, status } = await createTask$({ projectId, document: task }).toPromise();
    ({ response, status } = await getTasks$({ id: response, projectId }).toPromise());
    dispatch(getTaskDone(response, callback));
  } catch (error) {
    dispatch(networkError({...error, number: '10125-'+error.status}));
  }
};

export const deleteTask = (projectId, taskId) => async (dispatch, getState) => {
  try {
    let { response, status } = await deleteTask$({ projectId, subId: taskId }).toPromise();
    dispatch(extractSubview([taskId]));
  } catch (error) {
    dispatch(networkError({...error, number: '10126-'+error.status}));
  }
};

export const updateTask = (projectId, task) => async (dispatch, getState) => {
  try {
    let taskId = task.id;
    let { response, status } = await updateTask$({ projectId, subId: taskId, document: task }).toPromise();
    let { response: response2, status: status2 } = await getTasks$({ projectId, id: taskId }).toPromise();
    dispatch(getTaskDone(response2));
  } catch (error) {
    dispatch(networkError({...error, number: '10127-'+error.status}));
  }
};



// WEBPACK FOOTER //
// ./src/actions/tasks.js